// Le client HTTP de l'API v1 : même origine, cookie HttpOnly, en-tête anti-CSRF, réponse
// validée par zod. Une erreur ne remonte jamais un texte : un code (traduit par l'écran) et
// une référence que le client peut citer au support.
import type { z } from "zod";
import { ErrorApi, LECTURAS, type Lectura } from "./esquemas";

export class ApiError extends Error {
  constructor(public estado: number, public codigo: string, public ref?: string) {
    super(codigo);
  }
}

const BASE = "/api/v1";

async function leer(r: Response) {
  const texto = await r.text();
  try {
    return texto ? JSON.parse(texto) : {};
  } catch {
    return {};
  }
}

export async function llamar(ruta: string, init?: RequestInit): Promise<unknown> {
  let r: Response;
  try {
    r = await fetch(BASE + ruta, {
      credentials: "same-origin",
      ...init,
      headers: { "Content-Type": "application/json", "X-Requested-With": "responia", ...(init?.headers ?? {}) },
    });
  } catch {
    throw new ApiError(0, "red");
  }
  const cuerpo = await leer(r);
  if (!r.ok) {
    const e = ErrorApi.safeParse(cuerpo);
    throw new ApiError(r.status, e.success ? e.data.error.codigo : "interno", e.success ? e.data.error.ref : undefined);
  }
  return cuerpo;
}

export async function leerRuta<L extends Lectura>(
  ruta: L,
  params?: Record<string, string>,
): Promise<z.infer<(typeof LECTURAS)[L]>> {
  const q = params ? `?${new URLSearchParams(params).toString()}` : "";
  const cuerpo = await llamar(ruta + q);
  const r = LECTURAS[ruta].safeParse(cuerpo);
  if (!r.success) {
    // Le serveur a changé de forme : on le dit comme une erreur interne, jamais un écran à moitié vide.
    console.error(`contrato ${ruta}`, r.error.issues.slice(0, 3));
    throw new ApiError(200, "interno");
  }
  return r.data as z.infer<(typeof LECTURAS)[L]>;
}

export async function escribir(ruta: string, cuerpo: unknown = {}): Promise<Record<string, unknown>> {
  return (await llamar(ruta, { method: "POST", body: JSON.stringify(cuerpo) })) as Record<string, unknown>;
}
